import { validationMixin } from "vuelidate"
import { required, requiredIf, minValue } from "vuelidate/lib/validators"
import Loading from "@/components/widgets/Loading.vue"
import Vue from "vue"
import Drawer from '@/components/drawers'
import VueSimpleSuggest from "vue-simple-suggest";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String
    },
    id: {
      type: String
    }
  },
  components: {
    Loading,
    Drawer,
    VueSimpleSuggest,
  },
  mixins: [validationMixin],
  data() {
    return {
      skuOptions: [],
      loading: false,
      drawerOpened: false,
      preview: null,
      showFileInput: true,
      inputType: 'file',
      fileError: '',
      file: null,
      code_description: "",
      unitLockedBySku: false,  // SKU มีหน่วยนับกำหนดแล้ว -> ล็อกช่อง (แสดงอย่างเดียว)
      skuCategoryName: null,   // หมวดสินค้าจาก master SKU (แสดงอย่างเดียว)
      // หน่วยที่เลือกกรอกได้: [{id: null = หน่วยเล็กสุด, name}, {id: unit_id หน่วยใหญ่, name, base_qty}]
      unitChoices: [],
      adjustMode: false,     // โหมดแก้ไข: กดปุ่ม "ปรับยอด" แล้วถึงแก้จำนวนได้
      skuExistsInStock: false, // SKU ที่เลือกมีในคลังแล้ว -> ซ่อนราคาขาย/จุดสั่งซื้อ
      form: {
        code: null,
        sku_id: null,
        unit_name: null,
        qualtity: null,
        status: 1,
        cost: null,
        price: null,
        note: null,
        image: null,
        input_unit_id: null, // หน่วยที่ใช้กรอกจำนวน (null = หน่วยเล็กสุดของ SKU)
        min_stock: null,     // จุดสั่งซื้อขั้นต่ำ (หน่วยเล็กสุด) ว่าง = ไม่ตั้ง
        lot_no: null,        // เลข lot ที่รับเข้า (ว่าง = ระบบตั้งให้)
        reason: null,        // เหตุผลตอนแก้จำนวนในโหมดแก้ไข (backend บังคับ)
      },
      originalQty: null,     // จำนวนเดิมตอนเปิดฟอร์มแก้ไข ไว้เช็คว่าแก้จำนวนหรือไม่
    }
  },
  validations: {
    form: {
      // รหัสบังคับเฉพาะตอนรับเข้า — รายการเก่าบางตัวไม่มีรหัส ถ้าบังคับจะแก้ไขไม่ได้เลย
      code: { required: requiredIf(function () { return this.mode !== 'update' }) },
      unit_name: { required },
      qualtity: {
        required,
        minValue: minValue(0),
      },
      status: { },
      // ต้นทุนบังคับเฉพาะตอนรับเข้า — ใช้คิดต้นทุนเฉลี่ย ไม่กรอก = มูลค่าคงคลังผิด
      cost: {
        required: requiredIf(function () { return this.mode !== 'update' }),
        minValue: minValue(0),
      },
      price: { },
      note: { },
    },
  },
  watch: {
    'opened'(n, o) {
      if (n) {
        this.showFileInput = true
        this.drawerOpened = n

        if (this.mode === 'update') {
          this.onInitData()
        }
      }
    }
  },
  computed: {
    // จำนวนที่จะถูกบันทึกจริง (หน่วยเล็กสุด) เมื่อกรอกเป็นหน่วยใหญ่
    convertedBaseQty() {
      if (!this.form.input_unit_id || !this.form.qualtity) return null
      const c = this.unitChoices.find(x => x.id === this.form.input_unit_id)
      if (!c || !c.base_qty) return null
      return (parseFloat(this.form.qualtity) * c.base_qty).toLocaleString()
    },
    isUpdate() {
      return this.mode === 'update'
    },
    // ราคาขาย/จุดสั่งซื้อ = คุณสมบัติของรายการ แก้ได้ตอนสร้างใหม่หรือหน้าแก้ไข
    // รับเข้าซ้ำรายการเดิม ไม่ให้แก้ (เดิมทับค่าเงียบ ๆ ทุกครั้งที่รับของ)
    canEditItemProps() {
      return this.isUpdate || !this.skuExistsInStock
    },
    // โหมดแก้ไข: จำนวนเปลี่ยนจากเดิม = เป็นการปรับยอด ต้องมีเหตุผล
    qtyChanged() {
      if (!this.isUpdate || !this.adjustMode || this.originalQty === null) return false
      return parseFloat(this.form.qualtity || 0) !== parseFloat(this.originalQty || 0)
    },
    reasonMissing() {
      return this.qtyChanged && !(this.form.reason && String(this.form.reason).trim())
    },
  },
  methods: {
    onCloseDrawer(event) {
      this.drawerOpened = false
      this.resetForm()
      this.$emit('close-event', { 
        status: true
      })
    },
    resetForm () {
      this.form.image = null
      this.form.code = null
      this.form.category_id = null
      this.form.name = null
      this.form.description = null
      this.form.unit_name = null
      this.form.qualtity = null
      this.form.status = 1
      this.form.cost = null
      this.form.price = null
      this.form.note = null
      this.unitLockedBySku = false
      this.skuCategoryName = null
      this.unitChoices = []
      this.form.input_unit_id = null
      this.form.min_stock = null
      this.form.lot_no = null
      this.form.reason = null
      this.originalQty = null
      this.adjustMode = false
      this.skuExistsInStock = false

      this.$nextTick(() => {
        this.$v.$reset()
      })

      this.onResetFileInput()
    },
    formBuilder(obj) {
      const d = obj.data || {}
      this.form.code = d.code ?? null
      this.form.category_id = d.category_id ?? null
      this.form.name = d.name ?? null
      this.form.description = d.description ?? null
      this.form.unit_name = d.unit_name ?? null
      this.form.qualtity = d.qualtity !== null && d.qualtity !== undefined ? parseFloat(d.qualtity) : null
      this.form.status = d.status ?? null
      this.form.cost = d.cost ?? null
      this.form.price = d.price ?? null
      this.form.note = d.note ?? null
      this.form.min_stock = d.min_stock !== null && d.min_stock !== undefined ? parseFloat(d.min_stock) : null
      this.form.reason = null
      this.originalQty = this.form.qualtity

      // โหมดแก้ไข: SKU/ชื่อ ต้องมาจากรายการเดิม (เดิมไม่เซ็ต -> ส่งชื่อว่างไปทับชื่อเดิมหาย)
      this.form.sku_id = d.sku_id ?? null
      this.code_description = d.name || (d.sku && d.sku.name) || ''
      this.unitLockedBySku = !!(d.sku && d.sku.unit && d.sku.unit.name)
      this.skuCategoryName = d.sku && d.sku.category ? d.sku.category.name_th : null
      // แก้ไขไม่ให้เลือกหน่วยใหญ่ — จำนวนในฟอร์มเป็นหน่วยเล็กสุดตามที่เก็บในคลัง
      this.unitChoices = []
      this.form.input_unit_id = null
    },
    onFileHandler(e) {
      this.$refs.fileInput.click()
    },
    onResetFileInput() {
      this.inputType = 'text'      
      this.$nextTick(() => {
        this.fileError = ''
        this.file = null
        this.inputType = 'file'    
      })
    },
    onFileChange(e) {
      if (e.target.files.length > 0) { 
        this.fileError = ''
        const selectedFile = e.target.files[0]
        // File type validation (accept only image files)
        const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg']
        if (!allowedFileTypes.includes(selectedFile.type)) {
          this.fileError = 'ไฟล์รูปภาพไม่ถูกต้อง. กรุณาเลิอกไฟล์รูปภาพ.'
          return;
        } 
        
        this.onFIletoBase64(selectedFile).then(file => {
          this.file = file
          this.form.image = file
        }).catch(error => {
          this.onExceptionHandler(error.message)
        })
      }      
    },
    onFIletoBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async onInitData() {
      try {
        this.loading = true

        const result = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/miscellaneous/${this.id}`)
        this.loading = false
        if (result.status === 200) {

          this.formBuilder(result)
        }
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },
    async onSubmitForm() {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$anyError) {
          return
        }
        if (this.reasonMissing) {
          return this.onExceptionHandler('การแก้จำนวนสินค้า ต้องระบุเหตุผล')
        }
        if (this.form.min_stock !== null && this.form.min_stock !== '' && parseFloat(this.form.min_stock) < 0) {
          return this.onExceptionHandler('จุดสั่งซื้อขั้นต่ำต้องไม่ติดลบ')
        }
        this.loading = true
        const formData = new FormData()
        if (this.form.image) {
          formData.append('image', this.form.image)
        }
        formData.append('code', this.form.code)
        formData.append('name', this.code_description)
        formData.append('sku_id', this.form.sku_id)
        formData.append('unit_name', this.form.unit_name)
        formData.append('qualtity', this.form.qualtity)
        formData.append('input_unit_id', this.isUpdate ? '' : (this.form.input_unit_id ?? ''))
        formData.append('status', this.form.status)
        formData.append('cost', this.form.cost)
        formData.append('note', this.form.note)
        // ราคาขาย/จุดสั่งซื้อ ส่งเฉพาะตอนที่แก้ได้จริง
        // (รับเข้าซ้ำรายการเดิม ไม่ส่ง = backend ไม่แตะค่าเดิม)
        if (this.canEditItemProps) {
          formData.append('price', this.form.price)
          formData.append('min_stock', this.form.min_stock ?? '')
        }
        if (this.isUpdate) {
          // ปรับยอดต้องกดปุ่มก่อน — backend ไม่แตะจำนวนถ้าไม่ส่ง flag นี้
          formData.append('adjust_stock', this.adjustMode ? 'true' : 'false')
          formData.append('reason', this.form.reason ?? '')
        } else {
          formData.append('lot_no', this.form.lot_no ?? '')
        }

        let result = {}
        if (this.mode === 'create') {
          result = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/miscellaneous`, formData)
        } else {
          result = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/miscellaneous/${this.id}`, formData)
        }
        this.loading = false
        setTimeout(() => {
          if (result.status === 201 || result.status === 200) {
            this.$swal({
              width: "29rem",
              padding: '1.825em',
              html: '<div class="d-flex flex-row align-items-center">' +
                '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
                '<div class="d-flex flex-column">'+
                '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
                `<span class="text-base text-left text-gray-500">${result.data?.message ?? "บันทึกข้อมูลเรียบร้อยแล้ว"}</span>`+
                '</div>'+
              '</div>',
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  popup: 'swal2-custom-rounded',
                  closeButton: 'text-3xl swal2-custom-close',
                  actions: 'justify-content-end',
                  contant: 'd-flex flex-row justify-content-around px-2',
                  title: 'd-none',
                  confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
                  cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
                },
                showCancelButton: false,
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
                showCloseButton: true,
            }).then(result => {
              this.onCloseDrawer()
            })
          }
        }, 500)
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },
    async loadSkuOptions() {
      this.skuOptions = [];
      try {
        const result = await this.$axios.get(`${this.$host}/api/v1/master/sku`);
        if (result) {
          this.skuOptions = result.data;
        }
      } catch (error) {
        this.busy = false;
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    checkSelect(e) {
      var checkIfSkuExisted = this.skuOptions.findIndex(p => p.full_code === e);
      if (checkIfSkuExisted === -1) {
        this.form.code = null
        this.code_description = ""
        this.unitLockedBySku = false
        this.skuCategoryName = null
        this.unitChoices = []
        this.form.input_unit_id = null
      }
      else {
        const sku = this.skuOptions[checkIfSkuExisted]
        this.form.sku_id = sku.id
        this.code_description = sku.name
        // หน่วยกรอกได้ = หน่วยเล็กสุด + หน่วยใหญ่ที่ตั้งตัวแปลงไว้
        const baseName = (sku.unit && sku.unit.name) ? sku.unit.name : (this.form.unit_name || 'หน่วยเล็กสุด')
        this.unitChoices = [{ id: null, name: baseName }].concat(
          (sku.unit_conversions || []).map(c => ({
            id: c.unit_id,
            name: (c.unit && c.unit.name) ? c.unit.name : ('หน่วย #' + c.unit_id),
            base_qty: parseFloat(c.base_qty),
          }))
        )
        this.form.input_unit_id = null
        // หน่วยนับ + หมวดสินค้า inherit จาก master SKU (/master/sku ส่ง relation unit/category มาด้วย)
        if (sku.unit && sku.unit.name) {
          this.form.unit_name = sku.unit.name
          this.unitLockedBySku = true
        } else {
          this.unitLockedBySku = false
        }
        this.skuCategoryName = (sku.category && sku.category.name_th) ? sku.category.name_th : null
        this.checkSkuInStock(sku.id)
      }
    },
    // SKU มีรายการในคลังแล้วหรือยัง — ถ้ามี ราคาขาย/จุดสั่งซื้อต้องไปแก้ที่หน้าแก้ไข
    async checkSkuInStock(skuId) {
      this.skuExistsInStock = false
      if (!skuId) return
      try {
        const params = new URLSearchParams({
          page: '1',
          per_page: '1',
          keyword: '',
          isBranchStock: 'true',
          sku_id: String(skuId),
        })
        const res = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/miscellaneous?${params.toString()}`
        )
        this.skuExistsInStock = ((res && res.data && res.data.total) || 0) > 0
      } catch (error) {
        // เช็คไม่ได้ = ปล่อยให้กรอกได้ (backend ยังกันการทับค่าอยู่)
        this.skuExistsInStock = false
      }
    },
  },
  async created() {
    await this.loadSkuOptions();
  },
}
